
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","viewBox":"0 0 1300 800"}, attrs),
              ...rest,
            },
            children.concat([_c('ellipse',{staticClass:"i-sun",attrs:{"cx":"650","cy":"400","fill":"#fff","rx":"274.505","ry":"275.329"}}),_c('path',{staticClass:"i-venus",attrs:{"fill":"#73D6D3","d":"M962.931 241.189a350.926 350.926 0 0 1-79.336 420.689 350.9 350.9 0 0 1-132.902 74.288l-21.571-72.015a275.73 275.73 0 0 0 174.31-155.484 275.74 275.74 0 0 0-7.538-233.457z"}}),_c('path',{staticClass:"i-mercury",attrs:{"fill":"#92B8B8","d":"M317.791 400a332.2 332.2 0 0 1 47.381-170.985l49.218 29.546A274.8 274.8 0 0 0 375.196 400z"}})])
          )
        }
      }
    